// This file should only contain action type constants.

export const SET_MAPPING = 'SET_MAPPING';
